import React, { useEffect, useState } from "react";
import { McInput } from "@maersk-global/mds-react-wrapper/mc-input";
import "../styles/LeadAndExecute.css";
import { format,toZonedTime } from "date-fns-tz"; 
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Switch,
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import apiClient from "../api/apiClient";
import ProjectStatus from "./ProjectStatus";
import CustomerOnboardingLite from "./CustomerOnboardingLite";
import { apiUrl } from "../authconfig";
const LiteCustomerForm = ({currentModalData,handleClose,setCurrentModalData}) => {
     const [isViewMore ,setIsViewMore] = useState(false)
      const [projectPhaseData, setProjectPhaseData] = useState();
      const currentUser = JSON.parse(sessionStorage.getItem("user"));
            const [cancelReason, setCancelReason] = useState();
            const [notInCurrentScopeReason, setNotInCurrentScopeReason] = useState();
  

      useEffect(() => {
        setProjectPhaseData(currentModalData);
      },[currentModalData])

      const handleSaveClick = (e) => {
        const hasFirstBookingReference = Boolean(
          String(projectPhaseData?.firstBookingReference || "").trim()
        );
        const hasActualGoLiveDate = Boolean(projectPhaseData?.actualGoLiveDate);
        const todayDate = new Date();
        const todayOnly = new Date(
          todayDate.getFullYear(),
          todayDate.getMonth(),
          todayDate.getDate()
        );
        const actualGoLiveDateOnly = hasActualGoLiveDate
          ? new Date(projectPhaseData.actualGoLiveDate)
          : null;

        if (
          actualGoLiveDateOnly &&
          !Number.isNaN(actualGoLiveDateOnly.getTime()) &&
          new Date(
            actualGoLiveDateOnly.getFullYear(),
            actualGoLiveDateOnly.getMonth(),
            actualGoLiveDateOnly.getDate()
          ) > todayOnly
        ) {
          alert("Actual Go-Live Date cannot be a future date.");
          return;
        }

        if (
          projectPhaseData?.projectStatus === "Complete" &&
          (!hasFirstBookingReference || !hasActualGoLiveDate)
        ) {
          alert(
            "1st booking reference number and Actual Go-Live Date are mandatory before closing the project."
          );
          return;
        }

        const agreementStartDate = projectPhaseData?.agreementStartDate
          ? new Date(projectPhaseData.agreementStartDate)
          : null;
        const actualGoLiveDate = actualGoLiveDateOnly;
        const isProjectGoLiveDelayedReasonRequired =
          agreementStartDate &&
          actualGoLiveDate &&
          !Number.isNaN(agreementStartDate.getTime()) &&
          !Number.isNaN(actualGoLiveDate.getTime()) &&
          Math.floor((actualGoLiveDate - agreementStartDate) / (1000 * 60 * 60 * 24)) > 15;

        if (
          isProjectGoLiveDelayedReasonRequired &&
          !String(projectPhaseData?.projectGoLiveDelayedReason || "").trim()
        ) {
          alert(
            "Project go-live delayed reason is required when Actual Go-Live Date is more than 15 days after Agreement Start Date."
          );
          return;
        }

        const hasContactingSalesSelection =
          typeof projectPhaseData?.contactingSales === "boolean";
        const isContactingSalesYes = projectPhaseData?.contactingSales === true;

        if (projectPhaseData?.projectStatus === "Complete" && !hasContactingSalesSelection) {
          alert("Please select whether this project involves contacting Sales for participation.");
          return;
        }

        if (
          projectPhaseData?.projectStatus === "Complete" &&
          isContactingSalesYes &&
          !String(projectPhaseData?.reasonForSalesParticipation || "").trim()
        ) {
          alert("Reason for sales participation is required when contacting Sales is Yes.");
          return;
        }

        if (
          projectPhaseData?.projectStatus === "Complete" &&
          isContactingSalesYes &&
          projectPhaseData?.reasonForSalesParticipation === "Others" &&
          !String(projectPhaseData?.reasonForSalesOther || "").trim()
        ) {
          alert("Please provide details for 'Others' under reason for sales participation.");
          return;
        }

        if (
    (projectPhaseData?.projectStatus === "Cancelled" && !cancelReason) ||
    (projectPhaseData?.projectStatus === "Not in Current Scope" && !notInCurrentScopeReason)
  ) {
    alert("Please select a further reason for the current project status selected.");
    return;
  }
         if (
         (projectPhaseData?.projectStatus == 'Cancelled' || projectPhaseData?.projectStatus == 'Not in Current Scope') ||
          (projectPhaseData?.estimatedGoLiveDate && projectPhaseData?.estimatedHypercareEndDate && projectPhaseData?.projectStatus)
          
         ) {
           apiClient
             .post(
               `${apiUrl}/api/opportunities/save`,
               {...projectPhaseData, fullOnboarding : false , liteOnboarding : true,modifiedBy:currentUser?.mail,
                 projectGoLiveDelayedReason: isProjectGoLiveDelayedReasonRequired
                  ? projectPhaseData?.projectGoLiveDelayedReason
                  : "",
                 projectSubstatus:
                projectPhaseData?.projectStatus === "Cancelled"
                  ? cancelReason
                  : projectPhaseData?.projectStatus === "Not in Current Scope"
                  ? notInCurrentScopeReason
                  : null,
                modifiedDate: format(toZonedTime(new Date(), "Europe/Copenhagen"), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX")}
             )
             .then((response) => {
               console.log(response);
               setCurrentModalData({
            ...projectPhaseData,
          });

               alert("Data saved successfully");
               handleClose();
             })
             .catch((error) => {
                if (error.response) {
                    if (error.response.status === 403) {
                      alert("Please fill all mandatory fields");
                    } else if (error.response.status === 400) {
                      alert(error.response.data || "Bad request");
                    } else {
                      alert("An error occurred. Please try again.");
                    }
                    console.log("error", error);
                  } else {
                    alert("An error occurred. Please try again.");
                    console.log("error", error);
                  }
                });
         }
         else{
           alert("Please fill the estimated Golive Date and Estimated Hypercare end date")
         }
       };
    
  return (

    <div>
      <div className="Project" style={{ color: "rgb(0, 36, 61)" }}>
        Project Details
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          gap: "25px",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Project ID</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.projectId || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Opportunity Close Won Date</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.closedWonDate || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Opportunity Reference</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.opportunityReference || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Account Name</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.accountName || ""}
            ></McInput>
          </div>
        </div>
      </div>
      {!isViewMore &&  <div style={{fontSize:'12px',display:'flex',alignItems:'center',cursor:'pointer'}} onClick={()=> setIsViewMore(true)}><AddIcon/>View More</div>}
     { isViewMore && <>
      <div
        style={{
          display: "flex",
          width: "100%",
          gap: "25px",
          justifyContent: "space-between",
          paddingTop: "10px",
        }}
      >
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Product Family</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.productBundles || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Opportunity Type</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.opportunityType || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Country Role</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.countryRole || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Agreement Start Date</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.agreementStartDate || ""}
            ></McInput>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          gap: "25px",
          justifyContent: "space-between",
          paddingTop: "10px",
        }}
      >
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Agreement End Date</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.agreementEndDate || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Gross Profit (USD)</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.grossProfit || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Total Revenue</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.totalRevenue || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Executing Country</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.executingCountry || ""}
            ></McInput>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          gap: "25px",
          justifyContent: "space-between",
          paddingTop: "10px",
        }}
      >
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Opportunity Owner Country</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.opportunityOwnerCountry || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Service Contract Number</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.serviceContractNumber || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Customer SCV code</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.customerScvCode || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Opportunity Name</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.opportunityName || ""}
            ></McInput>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          gap: "25px",
          justifyContent: "space-between",
          paddingTop: "10px",
        }}
      >
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Opportunity Owner</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.opportunityOwner || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Closed Won Date</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.closedWonDate || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Vertical</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.vertical || ""}
            ></McInput>
          </div>
        </div>
         <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Brand</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.brand || ""}
            ></McInput>
          </div>
        </div>
        {/* <div style={{ display: "flex", width: "25%" }}></div> */}
      </div>
      </> 
      }
    { isViewMore && <div style={{fontSize:'12px',display:'flex',alignItems:'center',cursor:'pointer'}} onClick={()=> setIsViewMore(false)}><RemoveIcon/>View Less</div>}
      <div className="Project"></div>
      <div className="Project">
        <div style={{ display: "flex", gap: "10px", paddingTop: "10px" }}>
          <div style={{ width: "40%" }}>
            <div
              className="ProjectTitle"
              style={{
                color: "rgb(0, 36, 61)",
                position: "sticky",
                top: 0,
                background: "white",
                borderBottom: "1px solid #ccc",
                zIndex: "1",
              }}
            >
              Customer Onboarding Lite
            </div>
            <div style={{ flex: 1, border: "1px solid #ccc", padding: "10px" }}>
              <div style={{ fontFamily: "Maersk Text", fontSize: "14px" }}>
                <CustomerOnboardingLite
                  projectPhaseData={projectPhaseData}
                  setProjectPhaseData={setProjectPhaseData}
                  handleSaveClick={handleSaveClick}
                  currentModalData={currentModalData}
                />
              </div>
            </div>
          </div>
          <div style={{ width: "60%" }}>
            <div
              style={{
                color: "rgb(0, 36, 61)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
                position: "sticky",
                top: 0,
                background: "white",
                borderBottom: "1px solid #ccc",
                zIndex: "1",
              }}
            >
              <div className="ProjectTitle">Project Status </div>{" "}
              <div style={{ textAlign: "right" }}>
                <Button
                className="closePhaseButton"
                  style={{
                    padding: "0 10px",
                    width: "max-content",
                    backgroundColor: "rgb(0, 36, 61)",
                    position: "sticky",
                  }}
                  variant="contained"
                  onClick={(e) => handleSaveClick(e)}
                  disabled={currentModalData?.projectStatus == 'Cancelled' || currentModalData?.projectStatus == 'Not in Current Scope' || currentModalData?.projectStatus == 'Complete' || currentModalData?.assignedUser != currentUser?.mail}
                >
                  Save Details
                </Button>
              </div>
            </div>
            <div style={{ flex: 1, border: "1px solid #ccc", padding: "10px" }}>
              <ProjectStatus
                projectPhaseData={projectPhaseData}
                isLiteModal={true}
                setProjectPhaseData={setProjectPhaseData}
                currentModalData={currentModalData}
                cancelReason={cancelReason}
                setCancelReason={setCancelReason}
                notInCurrentScopeReason={notInCurrentScopeReason}
                setNotInCurrentScopeReason={setNotInCurrentScopeReason}
              />
            </div>
          </div>
        </div>
      </div>
      
    </div>
  )
}

export default LiteCustomerForm
